import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */

// Section 1
const HAS_ACCOMMODATIONS = 'has_accommodations'
const HAS_MODIFICATIONS = 'has_modifications'
const ACCOMMODATIONS = 'accommodations'
const MODIFICATIONS = 'modifications'
const DESCRIPTION = 'description'
const DONE = 'done'

/**
 * Form model
 */
const formModel = () => {
  return {
    [HAS_ACCOMMODATIONS]: {
      label: `${t('rti.has-accommodations')}`,
      name: HAS_ACCOMMODATIONS,
    },
    [HAS_MODIFICATIONS]: {
      label: `${t('rti.has-modifications')}`,
      name: HAS_MODIFICATIONS,
    },
    [ACCOMMODATIONS]: {
      label: `${t('common.accommodations')}`,
      name: ACCOMMODATIONS,
    },
    [MODIFICATIONS]: {
      label: `${t('common.modifications')}`,
      name: MODIFICATIONS,
    },
    [DESCRIPTION]: {
      label: `Description`,
      name: DESCRIPTION,
    },
    [DONE]: {
      label: `Done`,
      name: DONE,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [HAS_ACCOMMODATIONS]: false,
  [HAS_MODIFICATIONS]: false,
  [ACCOMMODATIONS]: [{
    category: null,
    items: []
  },],
  [MODIFICATIONS]: [{
    category: null,
    items: []
  },],
  [DESCRIPTION]: '',
  [DONE]: false,
}


export default formModel
